@let itemsValue = items();
@let expandedById = expandedBy();
@if (itemsValue.length) {
  @if (expandedByItem(); as expandedByItem) {
    <div
      @actions-nav
      class="expanded-container"
      [class.expanded-container--fill]="expandedByItem.fillHeight"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="expandedByItem.label | translate">
      @if (!expandedByItem.hideHeader) {
        <div class="expanded-header">
          <span class="label">
            {{ expandedByItem.label | translate }}
          </span>
          <sxw-svg-icon
            class="icon"
            name="cross"
            fillColor="var(--p-primary-600)"
            strokeColor="var(--p-primary-600)"
            (click)="expandedBy.set(undefined)"></sxw-svg-icon>
        </div>
      }
      <div class="expanded-body">
        <ng-container *ngTemplateOutlet="expandedByItem.template"></ng-container>
      </div>
    </div>
  }

  <ul class="items-container">
    @for (item of itemsValue; track item.id; let idx = $index) {
      <li
        class="item"
        [pTooltip]="item?.tooltip ?? '' | translate"
        tooltipPosition="left"
        (click)="selectItem(item)"
        [class.isActive]="expandedById === item.id">
        @if (item.icon) {
          <sxw-svg-icon
            width="15"
            height="15"
            [name]="item.icon"
            [fillColor]="expandedById === item.id ? 'white' : '#7f56d9'"
            [strokeColor]="expandedById === item.id ? 'white' : '#7f56d9'"></sxw-svg-icon>
        }
      </li>
    }
  </ul>
}
